// extracted by mini-css-extract-plugin
export default {"container":"CandidateBio_container__ft+1o","header":"CandidateBio_header__-gCoV","content":"CandidateBio_content__C0qjQ","about":"CandidateBio_about__tvAqq"};